import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=de3958e4&scoped=true"
import script from "./icons.vue?vue&type=script&lang=js"
export * from "./icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3958e4",
  null
  
)

export default component.exports